export class InvoiceCustomerPremium {
    id: string;
    amount: number;
    newWrittenPremium?: number;
    adjustedWrittenPremium?: number;
    retWrittenPremium?: number;
    changedDate: Date;
    enteredDate: Date;
}
